import { useEffect, useState } from 'react';

import { Option } from '../../../types';
import {
  BadgeList,
  StyledBadge,
  StyledBadgeWrapper,
  StyledChevronDown,
  StyledSelectAccordion,
  StyledSelectWrapper,
} from './styled';

type Props = {
  selectedItems: Option[];
  handleUnselectItem: (item: Option) => void;
};

const SelectedItemsComponent = ({ selectedItems, handleUnselectItem }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (selectedItems.length === 0) setIsOpen(false);
  }, [selectedItems.length]);

  const handleOpenSelections = (): void => {
    if (selectedItems.length > 0) setIsOpen((state) => !state);
  };

  return (
    <StyledSelectWrapper>
      <StyledSelectAccordion
        data-testid="selectAccordion"
        onClick={handleOpenSelections}
        disabled={selectedItems.length === 0}
      >
        <StyledChevronDown data-testid="chevronDownIcon" $isOpen={isOpen} />
        Selected{selectedItems.length > 0 && `(${selectedItems.length})`}
      </StyledSelectAccordion>
      {isOpen && (
        <BadgeList>
          {selectedItems.map((el) => (
            <StyledBadgeWrapper data-testid="badgeWrapper" key={el.value}>
              <StyledBadge key={el.value} text={el.label} onRemove={(): void => handleUnselectItem(el)} />
            </StyledBadgeWrapper>
          ))}
        </BadgeList>
      )}
    </StyledSelectWrapper>
  );
};

export default SelectedItemsComponent;
